import { DEPARTMENT_ERROR_MESSAGES } from "@src/features/employee_management/utils/department_constants";
import { Rule } from "antd/lib/form";

export const requiredRule = {
  whitespace: true,
  required: true,
  message: DEPARTMENT_ERROR_MESSAGES.EMPTY,
};

export function getValidatorRulesForOrgUnit(
  checkIfOrgCodeExists: (value: string) => boolean = null
): Rule[] {
  return [
    requiredRule,
    {
      pattern: /^[A-Z-]{3,9}$/,
      message: DEPARTMENT_ERROR_MESSAGES.INCORRECT_ORG_UNIT_FORMAT,
    },
    {
      validator(_, value) {
        if (checkIfOrgCodeExists?.(value)) {
          return Promise.reject(new Error(DEPARTMENT_ERROR_MESSAGES.DUPLICATE));
        }
        return Promise.resolve();
      },
    },
  ];
}
